import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/FeaturesCarouselComments';
import { Carousel } from './components/FeaturesCarouselComments';
import { Comments } from './components/FeaturesCarouselComments';
import Updates from './components/UpdatesAppContact';
import { AppSection } from './components/UpdatesAppContact';
import { ContactSection } from './components/UpdatesAppContact';
import { IndexSection } from './components/IndexCardsRanking';
import { CardsSection } from './components/IndexCardsRanking';
import { RankingSection } from './components/IndexCardsRanking';
import { MediaSection } from './components/MediaAboutTopicsFaq';
import { AboutSection } from './components/MediaAboutTopicsFaq';
import { TopicsSection } from './components/MediaAboutTopicsFaq';
import { FaqSection } from './components/MediaAboutTopicsFaq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <Features />
        <Carousel />
        <Comments />
        <Updates />
        <AppSection />
        <ContactSection />
        <IndexSection />
        <CardsSection />
        <RankingSection />
        <MediaSection />
        <AboutSection />
        <TopicsSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}